import React, { useEffect } from "react";
import "./App.css";
import ErrorBoundary from "./components/common/errorBoundary";
import { FabllbackProvider } from "./components/common/fallback";
import { Routes } from "react-router";
import { Route } from "react-router-dom";
import { useAxiosInterceptor } from "./services/api";
import { ProtectedRoute } from "./components/common/protectedRoute";

const SectionList = React.lazy(() => import("./pages/section/index"));
const CategoryList = React.lazy(() => import("./pages/category/index"));
const BrandList = React.lazy(() => import("./pages/brand/index"));
const DashboardList = React.lazy(() => import("./pages/dashboard/index"));
const Customers = React.lazy(() => import("./pages/customer/index"));
const CustomerViewEntry = React.lazy(() => import("./pages/customer/id"));
const ProductList = React.lazy(() => import("./pages/product/index"));
const ProductViewEntry = React.lazy(() => import("./pages/product/id"));
const PlanList = React.lazy(() => import("./pages/plan/index"));
const Order = React.lazy(() => import("./pages/order/index"));
const PlanViewEntry = React.lazy(() => import("./pages/plan/id"));
const LandingList = React.lazy(() => import("./pages/landing/index"));
const TrainingList = React.lazy(() => import("./pages/training/index"));
const EnrollmentList = React.lazy(() => import("./pages/enrollment/index"));
const ProjectList = React.lazy(() => import("./pages/project/index"));
const ProjectViewEntry = React.lazy(() => import("./pages/project/id"));
const OrganizationList = React.lazy(() => import("./pages/organization/index"));
const OrganizationViewEntry = React.lazy(() => import("./pages/organization/id"));
const InvoiceList = React.lazy(() => import("./pages/invoice/index"));
const InvoiceViewEntry = React.lazy(() => import("./pages/invoice/id"));
const BookOrderPage = React.lazy(() => import("./pages/order/book"));
const SetupList = React.lazy(() => import("./pages/setup/index"));
const Login = React.lazy(() => import("./pages/auth/login"));

function App() {
  const { setupInterceptors } = useAxiosInterceptor();

  useEffect(() => setupInterceptors(), [setupInterceptors]);

  return (
    <div className="">
      <ErrorBoundary>
        <FabllbackProvider>
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <DashboardList />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/section"
              element={
                <ProtectedRoute>
                  <SectionList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/category"
              element={
                <ProtectedRoute>
                  <CategoryList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/brand"
              element={
                <ProtectedRoute>
                  <BrandList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/product"
              element={
                <ProtectedRoute>
                  <ProductList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/product/:id"
              element={
                <ProtectedRoute>
                  <ProductViewEntry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan"
              element={
                <ProtectedRoute>
                  <PlanList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan/:id"
              element={
                <ProtectedRoute>
                  <PlanViewEntry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order"
              element={
                <ProtectedRoute>
                  <Order />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order/book"
              element={
                <ProtectedRoute>
                  <BookOrderPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/landing"
              element={
                <ProtectedRoute>
                  <LandingList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/training"
              element={
                <ProtectedRoute>
                  <TrainingList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/enrollment"
              element={
                <ProtectedRoute>
                  <EnrollmentList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/project"
              element={
                <ProtectedRoute>
                  <ProjectList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/project/:id"
              element={
                <ProtectedRoute>
                  <ProjectViewEntry />
                </ProtectedRoute>
              }
            />

            <Route
              path="/organization"
              element={
                <ProtectedRoute>
                  <OrganizationList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/organization/:id"
              element={
                <ProtectedRoute>
                  <OrganizationViewEntry />
                </ProtectedRoute>
              }
            />

            <Route
              path="/invoice"
              element={
                <ProtectedRoute>
                  <InvoiceList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice/:id"
              element={
                <ProtectedRoute>
                  <InvoiceViewEntry />
                </ProtectedRoute>
              }
            />

            <Route
              path="/setup"
              element={
                <ProtectedRoute>
                  <SetupList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/customer"
              element={
                <ProtectedRoute>
                  <Customers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer/:id"
              element={
                <ProtectedRoute>
                  <CustomerViewEntry />
                </ProtectedRoute>
              }
            />
          </Routes>
        </FabllbackProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
